import { AgentLlmDefaultSchema, isCustomLlmProvider, type AgentLlmDefault } from '@easyflow/shared';
import { apiClient } from '@/lib/api';
import { inferProviderFromModelFrontend } from '@/components/ai/LLMProviderConfig';

/**
 * Provider e modello con cui nasce un nuovo agente: il modello predefinito
 * degli agenti del tenant (Routing AI → Agenti AI, impostato dal preset per
 * embedder). null se non disponibile: il modale tiene i suoi valori.
 */
export async function fetchAgentLlmDefault(): Promise<AgentLlmDefault | null> {
  try {
    // Risposta validata con lo schema condiviso: nessuna fiducia sul tipo dichiarato.
    const res = await apiClient.get<unknown>('/chatbot/agent-llm-default');
    const parsed = AgentLlmDefaultSchema.nullable().safeParse(res.data ?? null);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

/**
 * Provider da mostrare aprendo un agente esistente: un agente Custom AI resta
 * Custom AI (il nome del modello non dice nulla sul provider); per gli altri
 * il modello salvato indica il provider, poi quello salvato.
 */
export function agentProviderForEdit(llmProvider: string | null | undefined, model: string | null | undefined): string {
  if (isCustomLlmProvider(llmProvider)) return llmProvider;
  return (model ? inferProviderFromModelFrontend(model) : null) || llmProvider || 'openai';
}
